module.exports = __webpack_public_path__ + "img/mon_64.e6a92342.png";